var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "collection-wrapper" }, [
    _c("div", { staticClass: "header" }, [
      _vm._v(" " + _vm._s(_vm.$t(_vm.errorHeading)) + " "),
    ]),
    _c("div", { staticClass: "main" }, [_vm._v(_vm._s(_vm.$t(_vm.errorMsg)))]),
    _c(
      "div",
      {
        staticClass: "collect-btn",
        on: {
          click: function ($event) {
            return _vm.$emit("hidePopup")
          },
        },
      },
      [_vm._v(" " + _vm._s(_vm.$t("Close")) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }